import { Button } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Typography } from 'antd';

interface Props {
  style?: React.CSSProperties;
  onClick: () => void;
}

const SettlementCompletedButton: React.FC<Props> = ({ style, onClick }) => {
  return (
    <Button
      buttonType="transparent"
      onClick={onClick}
      style={{
        color: colorTokens.textDescription,
        ...style,
      }}
    >
      <Typography.Text
        style={{
          color: colorTokens.textDescription,
        }}
      >
        증빙 완료
      </Typography.Text>
    </Button>
  );
};

export default SettlementCompletedButton;
